import React from 'react';

import { FieldCheckbox } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';

import css from './MarketingConsent.module.css';

/**
 * A component that renders the marketing consent checkbox.
 * Placed typically below TermsAndConditions.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.formId] - Optional form id to namespace the input id
 * @returns {JSX.Element}
 */
const MarketingConsent = props => {
  const { formId } = props;
  return (
    <div className={css.root}>
      <FieldCheckbox
        name="marketingConsent"
        id={formId ? `${formId}.marketingConsent` : 'marketingConsent'}
        textClassName={css.finePrint}
        label={<FormattedMessage id="AuthenticationPage.marketingConsentLabel" />}
      />
    </div>
  );
};

export default MarketingConsent;
